import styled from 'styled-components'

export const Stamp = styled.div`
    margin-right: 5px;
    width: 159.69px;
    height: 20px;
    background-position: 8px center;
    background-color: #f3123c;
    line-height: 14px;
    font-size: 12px;
    font-weight: 500;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 11px;
    &::after {
        content: '';
        background-image: url('/assets/img/card_autopago/logo-autopago_white_filled_text.svg');
        background-repeat: no-repeat;
        width: 63.95px;
        height: 14px;
        margin-left: 8px;
    }
`

export const Text = styled.div`
    position: relative;
    top: .5px;
`
